module.exports = __webpack_public_path__ + "static/media/preventivo_amarillo.5ecc55e8.svg";